<app-content-layout-wrapper>
  <div class="title">
    {{ 'SUCCESS_PAGE.' + successType + '.TITLE' | translate }}
  </div>
  <div class="sub-title">
    {{
      'SUCCESS_PAGE.' + successType + '.MESSAGE'
        | translate
          : {
              dueDate: contract.payment.due_date
            }
    }}
  </div>
  <object type="image/svg+xml" data="../../../assets/images/success.svg"></object>

  <hr class="divider" />

  <div>
    <div class="sum">
      <div>{{ 'PAYMENT_CONFIRMATION.DUE_DATE' | translate }}</div>
      <div class="due-date">
        {{ contract.payment.due_date }}
      </div>
    </div>
    <div class="sum">
      <div>{{ 'PAYMENT_CONFIRMATION.AMOUNT' | translate }}</div>
      <div class="total">{{ contract.amount | number }} {{ contract.currency }}</div>
    </div>
  </div>

  <button pButton pRipple class="simple-button mt-4 md:w-9" (click)="redirect()">
    {{ 'SUCCESS_PAGE.' + successType + '.BUTTON' | translate }}
  </button>
  <div class="ps" [innerHTML]="'SUCCESS_PAGE.' + successType + '.PS' | translate"></div>
</app-content-layout-wrapper>
